import type { JSX } from 'react';
import { cn } from '@beatq/ui';

export function LiveMarker({
  connected,
  label,
}: {
  connected: boolean;
  /** Override when connected. Default "Live". When not connected the visible text is "Polling". */
  label?: string;
}): JSX.Element {
  const text = connected ? (label ?? 'Live') : 'Polling';
  return (
    <span
      className={cn('a01-live', !connected && 'a01-live--poll')}
      role="status"
      data-live={connected ? 'true' : 'false'}
    >
      <span className="a01-live__dot" aria-hidden>
        {connected ? '●' : '○'}
      </span>
      {text}
    </span>
  );
}
